module.exports = __webpack_public_path__ + "img/dateImg_c.b8b4ca5e.png";